export default {"src":"/_next/static/media/kesfet.3e031668.svg","height":19,"width":68};